import React from 'react';
import './PlaceholderPage.css';

const EbaySettingsPage = () => {
  return (
    <div className="placeholder-page">
      <h1 className="page-title">eBay Settings</h1>
      <p className="page-description">
        eBay configuration including Location Set and Policies Set will be added here.
      </p>
      
      <div className="settings-list">
        <div className="setting-item">
          <span className="setting-label">Location Set</span>
          <span className="setting-status">Not configured</span>
        </div>
        <div className="setting-item">
          <span className="setting-label">Policies Set</span>
          <span className="setting-status">Not configured</span>
        </div>
      </div>
    </div>
  );
};

export default EbaySettingsPage;
